// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledScrollbar } from "@adl/XDL/Utilities";
import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import Info from "@insite/mobius/Icons/Info";
import { css } from "styled-components";

createUserModalStyles.container = {
    gap: 22,
};

createUserModalStyles.roleSelect = {
    labelProps: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
};

createUserModalStyles.roleGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};

createUserModalStyles.approverGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};

createUserModalStyles.settingsHeadingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

createUserModalStyles.approverSelectTooltip = {
    iconProps: {
        src: Info,
        css: css`
            margin-left: 0;
        `,
    },
};

createUserModalStyles.roleSelectHelpIcon = {
    src: HelpCircle,
    color: "secondary.main",
    size: 16,
    css: css`
        margin-left: 5px;
        cursor: pointer;
    `,
};

createUserModalStyles.roleSelect = {
    cssOverrides: {
        formField: css`
            label {
                display: flex;
                align-items: center;
            }
        `,
    },
};

createUserModalStyles.buttonsGridItem = {
    css: css`
        justify-content: space-between;
    `,
    width: 12,
};

createUserModalStyles.roleSelectHelpModal = {
    cssOverrides: {
        modalContent: css`
            ${styledScrollbar(8)}
        `,
    },
};
